import type { UmbracoFormField } from 'types/blocks';

export default function useForm() {
  function getDefaultFormField(field: UmbracoFormField) {
    return {
      label: field.settings.showLabel === 'True' ? field.caption : '',
      name: field.alias,
      placeholder: field.placeholder ?? field.settings.placeholder ?? '',
    };
  }
  return { getDefaultFormField };
}
